import { render, staticRenderFns } from "./TaxNumber.vue?vue&type=template&id=32a27243&"
import script from "./TaxNumber.vue?vue&type=script&lang=js&"
export * from "./TaxNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports